//export const BASEURL = "https://apicopy.bethlehem.edu:5001";
//export const BASEURL = "https://localhost:5001";
export const BASEURL = "https://api.bethlehem.edu:5001";
